import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  mutation CreateExternalMediaItem(
    $courseId: String!
    $subjectId: String!
    $input: CreateExternalMediaItemInput!
  ) {
    createExternalMediaItem(
      courseId: $courseId
      subjectId: $subjectId
      input: $input
    )
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/external"
        method: "POST"
      ) {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
